<div class="row relative">
  <div class="absolute">
    <button (click)="printPdf()" class="pdfButton" mat-flat-button>
      PDF<mat-icon class="redPDf">cloud_download</mat-icon>
    </button>
    <mat-icon class="iconClose" (click)="close()">close</mat-icon>
  </div>
  <div class="col-12">
    <img class="image" src="assets/images/logo_analytiko.png" alt="" />
  </div>
  <h2 class="col-12">Resumen del caso {{ data.iCase.gai }}</h2>
  <div class="col-4">
    <div class="info-content">
      <ng-container *ngFor="let item of firstBlock">
        <p class="title">
          <b>{{ item.title }}:</b> {{ item.text }}
        </p>
      </ng-container>
    </div>
  </div>
  <div class="col-4">
    <div class="info-content">
      <ng-container *ngFor="let item of secondBlock">
        <p class="title">
          <b>{{ item.title }}:</b> {{ item.text }}
        </p>
      </ng-container>
    </div>
  </div>
  <div class="col-4">
    <div class="info-content">
      <ng-container *ngFor="let item of thirdBlock">
        <p class="title">
          <b>{{ item.title }}:</b> {{ item.text }}
        </p>
      </ng-container>
    </div>
  </div>
</div>

<div *ngFor="let task of taskData">
  <div class="separator"></div>
  <p><b>Título:</b> {{ task.title }}</p>
  <p><b>Descricion:</b> {{ task.description }}</p>
  <p><b>Estado:</b> {{ statusTask[task.status] }}</p>
  <p *ngIf="task.task.requiresObservations">
    <b>Observación:</b>{{ task.observations ? task.observations : "" }}
  </p>
  <p><b>Creado:</b> {{ task.createdAt | date : "d/MM/yyyy h:mm a" }}</p>
  <p *ngIf="task.updatedAt">
    <b>Actualizado:</b> {{ task.updatedAt | date : "d/MM/yyyy h:mm a" }}
  </p>
  <div *ngIf="task.valuesObject">
    <div *ngFor="let valuesObject of task.valuesObject.data">
      <p>
        <b>{{ valuesObject.key }}:</b> {{ valuesObject.value }}
      </p>
    </div>
  </div>
  <div *ngIf="task.valuesObject">
    <table *ngIf="task.valuesObject2.dataTable">
      <!-- Encabezados -->
      <tr *ngFor="let fila of task.valuesObject2.dataTable; let i = index">
        <!-- Datos -->
        <td *ngFor="let dato of fila">
          <p [ngClass]="i == 0 ? 'bold' : ''">{{ dato }}</p>
        </td>
      </tr>
    </table>
  </div>
</div>
